import { SYSField } from "./library/forms/actions"
import { FieldVal } from "./library/forms/fieldapi"
import { ValidatorOptions } from "./library/forms/validators"
import { T } from "./textapi"

export const validatorsValidation = {
  Email: {},
  EmailList: {},
  Mandatory: {},
  MandatoryAllowEmptyString: {},
  MandatoryCheck: {},
  ExactLength: {},
  IntegerRange: {},
  MinLength: {},
  MaxLength: {},
  NotBeforeToday: {},
  NotLaterThanDaysFromToday: {},
  Regex: {},
}

const ensureOptionsVal = (field: SYSField, options: ValidatorOptions): any => {
  if (options?.val === undefined) {
    throw Error(`Validator needs options.val: ${field.fieldKey}`)
  }
  return options.val
}
export type ValidatorFnType = (
  field: SYSField,
  options: ValidatorOptions
) => boolean

export const SYSValidatorsFunctions: {
  [key in keyof typeof validatorsValidation]: ValidatorFnType
} = {
  Email: (field: SYSField, options: ValidatorOptions) => {
    if (!field.value) {
      return false
    }
    return field.value && !validateEmail(field.value)
  },

  EmailList: (field: SYSField, options: ValidatorOptions) => {
    if (!field.value) {
      return false
    }
    let sep = options?.val
    if (!sep) {
      sep = ";"
    }
    if (field.value.trim() === sep) {
      return true
    }
    return field.value && !validateEmail(field.value, sep)
  },

  Mandatory: (field: SYSField, options: ValidatorOptions) => {
    let val = field.list ? field.convertedValue : field.value
    return val === null || val === ""
  },

  MandatoryAllowEmptyString: (field: SYSField, options: ValidatorOptions) => {
    let val = field.list ? field.convertedValue : field.value
    return val === null
  },

  MandatoryCheck: (field: SYSField, options: ValidatorOptions) => {
    let val = field.convertedValue

    return val !== field.ui.checkedValue
  },

  ExactLength: (field: SYSField, options: ValidatorOptions) => {
    let val = ensureOptionsVal(field, options)
    if (field.value && field.value.length !== parseInt(val)) {
      // that means we get like "Can be max {1} characters". and to know the {1} we need the additinalTranslationReps set here...
      options.validation.translationReps.push(val)
      return true
    }
  },

  IntegerRange: (field: SYSField, options: ValidatorOptions) => {
    let val = ensureOptionsVal(field, options)
    if (
      field.value &&
      (parseInt(field.value) < val.min || parseInt(field.value) > val.max)
    ) {
      options.validation.translationReps.push(val.min)
      options.validation.translationReps.push(val.max)

      return true
    }
  },

  MinLength: (field: SYSField, options: ValidatorOptions) => {
    let val = ensureOptionsVal(field, options)
    if (!field.value || field.value.length < parseInt(val)) {
      // that means we get like "Can be max {1} characters". and to know the {1} we need the additinalTranslationReps set here...
      options.validation.translationReps.push(val)
      return true
    }
  },
  MaxLength: (field: SYSField, options: ValidatorOptions) => {
    let val = ensureOptionsVal(field, options)
    if (field.value && field.value.length > parseInt(val)) {
      // that means we get like "Can be max {1} characters". and to know the {1} we need the additinalTranslationReps set here...
      options.validation.translationReps.push(val)
      return true
    }
  },

  NotBeforeToday: (field: SYSField, options: ValidatorOptions) => {
    if (field.type !== "date") {
      throw Error(
        `Validator NotBeforeToday works only on date fields...Field: ${field.fieldKey}`
      )
    }
    let dVal = new Date(field.convertedValue)
    let refDVal = new Date()
    refDVal.setHours(0, 0, 0, 0)
    if (dVal.getTime() < refDVal.getTime()) {
      return true
    }
  },
  NotLaterThanDaysFromToday: (field: SYSField, options: ValidatorOptions) => {
    if (field.type !== "date") {
      throw Error(
        `Validator NotLaterThanDaysFromToday works only on date fields...Field: ${field.fieldKey}`
      )
    }
    let val = ensureOptionsVal(field, options)
    let dVal = new Date(field.convertedValue)
    let refDVal = new Date()
    refDVal.setDate(refDVal.getDate() + val)
    if (dVal.getTime() > refDVal.getTime()) {
      options.validation.translationReps.push(val)
      return true
    }
  },
  Regex: (field: SYSField, options: ValidatorOptions) => {
    // if (field.type !== "text") {
    //   throw Error(
    //     `Validator Regex works only on text fields...Field: ${field.fieldKey}`
    //   )
    // }
    let fieldVal = field.value

    if (fieldVal !== null) {
      fieldVal = fieldVal.toString()
    }

    let val = ensureOptionsVal(field, options)
    if (val.val !== undefined && val.val !== null) {
      val.val = val.val.toString()
    }
    let r = new RegExp(val.val)
    if (!r.test(fieldVal)) {
      options.validation.translationReps.push(T(val.msg))
      return true
    }
  },
}
function validateEmail(email, separator: string = undefined) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (separator) {
    var emailList: string[] = email.split(separator)

    return !emailList.some((s) => {
      return !(s.trim() === "" || re.test(String(s.trim()).toLowerCase()))
    })
  } else {
    return re.test(String(email.trim()).toLowerCase())
  }
}
